import { Component, OnInit, Input } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, UntypedFormArray } from "@angular/forms";
import { CONSTANTS } from "../../models/constant.model";

@Component({
  selector: "app-label",
  templateUrl: "./label.component.html",
  styleUrls: ["./label.component.css"]
})
export class LabelComponent implements OnInit {
  @Input()
  materialFormGroup: UntypedFormGroup;
  @Input()
  category;

  constructor() {}

  ngOnInit() {
    this.onChanges();
  }

  onChanges() {

    const catCtlArray = (
      this.materialFormGroup.get(CONSTANTS.CATEGORYCTRL)
    ) as UntypedFormArray;
    catCtlArray.valueChanges.subscribe(val => {
      const subTotal = this.getMaterialTotalReport();

      const subTotalCtl = (
        this.materialFormGroup.get(CONSTANTS.GENERATEDTONS)
      ) as UntypedFormControl;

      subTotalCtl.setValue(subTotal);
    });
  }


  getMaterialTotalReport() {
    let total = 0;


    const categoryList = Object.keys(this.category);
    categoryList.forEach(cat => {
      if (
        this.category[cat].value !== "NA" &&
        this.category[cat].value !== ""
      ) {

        const emissionReport =
          this.category[cat]["value"] * this.category[cat]["emissionFactor"];
        total = total + emissionReport;

      }
    });
    return this.getRoundOf(total);
  }

  getRoundOf(report) {
    return Math.round(report * 10) / 10;
  }
}
